//import axios from "axios";
import {api} from "hooks/axios"
import {SET_ASSETS, ADD_ASSET, GET_ASSETS} from "../actions/actionTypes"
import store from '../configureStore';

export const getAssets = (bookId)=>{
    return((dispatch)=>{
        //console.log("b")
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const assets = await api.post('books/get_assets/'+bookId)
                /*
                if(assets.data.length==0){
                    reject("empty")
                }
                */
                //console.log(assets.data.length==0)
                dispatch(setAssets(assets.data))
                resolve(assets.data)
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            return val
        })
        .catch(
            (error)=>{
                return error
            }
        )

    })
}

export const getAssetsHistory = (bookId,month,year) => {
    return((dispatch)=>{
        //console.log("b")
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const book = await api.post('bookHistory/get_assets_history/bookId='+bookId+'&month='+month+'&year='+year)
                //console.log(book.data)
                //if(Object.keys(book.data).length!==0){
                    dispatch(setAssets(book.data))
                //console.log(books)
                resolve(book);
                //}
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                //dispatch(setUser(val))
                //console.log(val)
                return val
                //return (val)

            }
            
        })

    })
}

export const createAsset = (data) => {
    //console.log(data)
    return((dispatch)=>{
        const promise = new Promise(async(resolve,reject)=>{
            try{
            var response
                response = await api.post('assets', {
                    book_id: data.bookId,
                    name: data.name,
                    desc: data.desc,
                    category: data.category,
                    type:data.type,
                    amount:data.amount,
                    active:1,
                })
            
            if(response.status=="200"||response.status=="201"){
                //props.handleClose()
                resolve(true)
            }
            //console.log(response.status)
            }catch(e){
                console.log(e)
            }
    //navigate("/books")
        })
        return promise
        .then(val=>{
            dispatch(getAssets(data.bookId))
            return val
        })
    })
}

export const updateAsset = (data) => {
    console.log(data)
    return((dispatch)=>{
        const promise = new Promise(async(resolve,reject)=>{
            try{
            var response
                response = await api.post('assets/update/'+data.assetId, {
                    book_id: data.bookId,
                    name: data.name,
                    desc: data.desc,
                    category: data.category,
                    type:data.type,
                    amount:data.amount,
                    active:data.active,
                })
            
            if(response.status=="200"||response.status=="201"){
                //props.handleClose()
                resolve(true)
            }
            console.log(response)
            }catch(e){
                console.log(e)
            }
    //navigate("/books")
        })
        return promise
        .then(val=>{
            dispatch(getAssets(data.bookId))
            return val
        })
    })
}

export const updateAssets = (data) => {
    return((dispatch)=>{
        

        const promise = new Promise(async(resolve,reject)=>{
            try {
                const response = await api.post('assets/updateAmount', {
                    data: JSON.stringify(data.assetsAmount),
                })
                if(response.status=="200"||response.status=="201"){
                    resolve(true)
                }
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                dispatch(getAssets(data.bookId))
                return val

            }
            
        })

    })
}

export const deleteAsset = (data) => {
    var state = store.getState()
    //console.log(state)
    return((dispatch)=>{
        const promise = new Promise(async(resolve,reject)=>{
            try{
            var response
                response = await api.post('assets/delete/'+data)
            
            if(response.status=="200"||response.status=="201"){
                //props.handleClose()
                resolve(true)
            }
            console.log(response)
            }catch(e){
                console.log(e)
            }
    //navigate("/books")
        })
        return promise
        .then(val=>{
            dispatch(getAssets(state.books.book_id))
            return val
        })
    })
}

export const setAssets = (item) => {
    //AsyncStorage.setItem("grow:auth:user",user.uid);
    //console.log(user)
    //addUser(user)
    //console.log(item)
    return{
        type: SET_ASSETS,
        item: item,
    }
}
export const addAsset = (item) => {
    //AsyncStorage.setItem("grow:auth:user",user.uid);
    //console.log(user)
    //addUser(user)
    //console.log(item)
    return{
        type: ADD_ASSET,
        item: item,
    }
}
